import utils from './utils'

class MyEcu {
  
  // chrome://device-log/
  
  static ECU_TYPE = {
    MP48__MP8C: "mp48",         // esteso 2 byte
    MP32__MP48_OBD: "mp48_obd", // esteso normale
    MP32_NEW: "mp32_new",       // esteso 2 byte
    DI60: "di60",               // esteso 2 byte ?? da confermare
  }

  setEcuType(ecu_type) { this.ecu_type = ecu_type; console.log("ecu_type: " + this.ecu_type); }
  setBaudRate(baud_rate) { this.baud_rate = baud_rate; console.log("baud_rate: " + this.baud_rate); }
  
  constructor(ecu_type, baud_rate) {
    this.setEcuType(ecu_type /*MyEcu.ECU_TYPE.MP48__MP8C*/)
    this.setBaudRate(baud_rate /*9600*/)
    this.progressChanged = undefined
    this.comPortChanged = undefined
  }

  report_progress(o) {
    if (this.progressChanged !== undefined) {
      this.progressChanged(o)
    }
  }
  report_progress_gen(title, data) {
    this.report_progress({ type: "gen", title: title, data: data })
  }

  async readEcuInfo() {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    if (this.ecu_type == MyEcu.ECU_TYPE.DI60) {
      if ((res = await this.commGetExtClient()) === undefined) return await this.commEND("comm ext client error")
    }
    if ((res = await this.commGetIdPcb()) === undefined) return await this.commEND("comm id pcb error")
    if ((res = await this.commGetSN()) === undefined) return await this.commEND("comm sn error")
    if ((res = await this.commGetSubClient()) === undefined) return await this.commEND("comm sub client error")
    if ((res = await this.commGetProdMarker()) === undefined) return await this.commEND("comm prod marker error")
    return await this.commEND(0)
  }

  async leaveBoot() {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (!res.isBoot) return await this.commEND("is NOT boot")    
    if ((res = await this.commCmdLeaveBoot()) === undefined) return await this.commEND("comm cmd leave boot error")
    if ((res = await this.commGetId("VERIFY ID")) === undefined) return await this.commEND("comm verify info res error")    
    return await this.commEND(0)
  }
  
  async setProdMarker(value) {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commSetProdMarker(value)) === undefined) return await this.commEND("comm set prod marker error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")
    return await this.commEND(0)
  }
  
  async fixEnergyReform(selected_client, sub_client_code, w0, w1) {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    
    if ((res = await this.commSetClient(selected_client)) === undefined) return await this.commEND("comm set client error")    
    
    var a = utils.hexStringToByteArray(sub_client_code)
    if ((res = await this.commSetSubClient(a)) === undefined) return await this.commEND("comm set sub client error")    
    
    var a_w0 = utils.hexStringToByteArray(w0)
    var a_w1 = utils.hexStringToByteArray(w1)
    if ((res = await this.commSetIdPcb(a_w0, a_w1)) === undefined) return await this.commEND("comm set id pcb error")    

    if ((res = await this.commGetId("VERIFY ID")) === undefined) return await this.commEND("comm verify info res error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")    
    return await this.commEND(0)
  }

  async fixNeutro(selected_client, sub_client_code, w0, w1) {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    
    if ((res = await this.commSetClient(selected_client)) === undefined) return await this.commEND("comm set client error")    
    
    var a = utils.hexStringToByteArray(sub_client_code)
    if ((res = await this.commSetSubClient(a)) === undefined) return await this.commEND("comm set sub client error")    
    
    var a_w0 = utils.hexStringToByteArray(w0)
    var a_w1 = utils.hexStringToByteArray(w1)
    if ((res = await this.commSetIdPcb(a_w0, a_w1)) === undefined) return await this.commEND("comm set id pcb error")    

    if ((res = await this.commGetId("VERIFY ID")) === undefined) return await this.commEND("comm verify info res error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")    
    return await this.commEND(0)
  }

  async fixClient(selected_client, stay_in_boot_after_fix) {
    var res = await this.commBEGIN()
    if (this.ecu_type === MyEcu.ECU_TYPE.DI60) return await this.commEND("ecu type not valid")
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    if ((res = await this.commSetClient(selected_client)) === undefined) return await this.commEND("comm set client error")    
    if ((res = await this.commGetId("VERIFY ID")) === undefined) return await this.commEND("comm verify info res error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")
    if (stay_in_boot_after_fix)
      if ((res = await this.commCmdJumpInBoot()) === undefined) return await this.commEND("comm cmd jump in boot error")
    return await this.commEND(0)
  }

  async fixDirInjClient(selected_client_value) {
    var res = await this.commBEGIN()
    if (this.ecu_type !== MyEcu.ECU_TYPE.DI60) return await this.commEND("ecu type not valid")
    if (res === false) return await this.commEND("comm port error")    
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    if ((res = await this.commGetExtClient()) === undefined) return await this.commEND("comm ext client error")
    if ((res = await this.commSetDirInjClient(selected_client_value)) === undefined) return await this.commEND("comm set client error")    
    if ((res = await this.commGetExtClient()) === undefined) return await this.commEND("comm ext client error")
    //if ((res = await this.commGetId("VERIFY ID")) === undefined) return await this.commEND("comm verify info res error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")
    return await this.commEND(0)
  }

  async changeSubClient(sub_client_code) {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if (sub_client_code.length % 2 !== 0) return await this.commEND("sub client len not % 2")
    if (sub_client_code.length !== 4) return await this.commEND("sub client len not 4")
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    var a = utils.hexStringToByteArray(sub_client_code)
    if ((res = await this.commSetSubClient(a)) === undefined) return await this.commEND("comm set sub client error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")
    return await this.commEND(0)
  }

  async changeModelCode(model_code) {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    if (model_code.length !== 2) return await this.commEND("model code len not 2")
    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")
    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")
    var a = utils.hexStringToByteArray(model_code)
    if ((res = await this.commSetModelCode(a)) === undefined) return await this.commEND("comm set sub client error")    
    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")
    return await this.commEND(0)
  }

  async changeIdPcb(w0, w1) {
    var res = await this.commBEGIN()
    if (res === false) return await this.commEND("comm port error")    
    
    if (w0.length % 2 !== 0) return await this.commEND("w0 len not % 2")
    if (w0.length !== 4) return await this.commEND("w0 len not 4")
    if (w1.length % 2 !== 0) return await this.commEND("w1 len not % 2")
    if (w1.length !== 4) return await this.commEND("w1 len not 4")

    if ((res = await this.commGetId()) === undefined) return await this.commEND("comm id error")
    if (res.isBoot) return await this.commEND("is boot")

    if ((res = await this.commGetConn()) === undefined) return await this.commEND("comm conn error")

    var a_w0 = utils.hexStringToByteArray(w0)
    var a_w1 = utils.hexStringToByteArray(w1)
    if ((res = await this.commSetIdPcb(a_w0, a_w1)) === undefined) return await this.commEND("comm set id pcb error")    

    if ((res = await this.commCmdMemSave()) === undefined) return await this.commEND("comm cmd mem save error")
    return await this.commEND(0)
  }

  // **************************************************************************
  // **************************************************************************
  // **************************************************************************
  
  async selectComPort() {
    //try {
    //  const ports = await navigator.serial.getPorts()
    //  if (ports.length > 0) {
    //    this.port = ports[0]
    //    console.log("port already granted")
    //  }       
    //} catch {
    //  console.log("get ports error")      
    //}
    
    try {
      this.port = await navigator.serial.requestPort()
      //console.log(this.port.getInfo())
    } catch {
      console.log("request port error")
    }

    if (this.port === undefined) {
      console.log("port undef")
      if (this.comPortChanged !== undefined) {
        this.comPortChanged(undefined)
      }
    } else {
      const { usbProductId, usbVendorId } = this.port.getInfo();
      if (this.comPortChanged !== undefined) {
        this.comPortChanged({
          usbProductId: usbProductId,
          usbVendorId: usbVendorId,
        })
      }
    }
  }

  // setta i seguenti:
  //   this.port
  //   this.keepReading
  //   this.closedPromise
  //   this.writer
  async commBEGIN() {
    this.report_progress({ type: "_working", data: 1 })

    const ports = await navigator.serial.getPorts()
    if (ports.length === 1) {
      this.port = ports[0]
      console.log("port already granted")
    } 
 
    if (this.port === undefined) {
      try {
        this.port = await navigator.serial.requestPort()
        //console.log(this.port.getInfo())
      } catch {
        console.log("request port error")
      }
    }
    
    if (this.port === undefined) {
      console.log("port undef")
      if (this.comPortChanged !== undefined) {
        this.comPortChanged(undefined)
      }
      return false
    }
    
    const { usbProductId, usbVendorId } = this.port.getInfo();
    if (this.comPortChanged !== undefined) {
      this.comPortChanged({
        usbProductId: usbProductId,
        usbVendorId: usbVendorId,
      })
    }
    
    try {
      await this.port.open({
        baudRate: this.baud_rate
      })
    } catch (error) {
      console.log("port already open")
      return false
    }

    if (this.reader === undefined) {
      this.keepReading = true
      this.closedPromise = this._read_until_closed()
    }
    
    this.writer = this.port.writable.getWriter()
    return true
  }

  async commEND(ret_msg) {
    this.report_progress({ type: "_working", data: 0 })
    this.report_progress({ type: "_result", data: ret_msg })
    await utils.sleep(250)
    try {
      this.writer.releaseLock()
    } catch (error) {      
    }
    try {
      await this._ecu_done()
    } catch (error) {      
    }
    return true
  }

  async commGetId(title = "ID") {
    const m = await this._write_bytes([0x00, 0x02], 10, 250)
    if (!m.valid) return undefined
    m.customer = m._b[5]
    m.model = m._b[6]
    m.fwVersion = m._b[8] + "." + m._b[7]    
    m.isBoot = (m._b[4] === 0x06)
    m.isBootStr = (m.isBoot) ? "True" : "False"
    //console.log(m)
    this.report_progress({ type: "id", title: title, data: m })
    await utils.sleep(50)
    return m
  }

  async commGetConn() {
    const m = await this._write_bytes([0x01, 0x00, 0x3a], 7, 250)
    if (!m.valid) return undefined
    //console.log(m)
    this.report_progress_gen("CONNECTION", m)
    await utils.sleep(50)
    return m
  }

  async commGetExtClient() {
    const m = await this._write_bytes([0x00, 0x18], 11, 250)
    if (!m.valid) return undefined
    var c0 = m._b[5] // random
    var c = [0,0,0,0]
    c[0] += ((m._b[6] ^ m._b[5]) & 0xff) //<<  0
    c[1] += ((m._b[7] ^ m._b[6]) & 0xff) //<<  8
    c[2] += ((m._b[8] ^ m._b[7]) & 0xff) //<< 16
    c[3] += ((m._b[9] ^ m._b[8]) & 0xff) //<< 24
    var client_code = 0
    client_code += c[3] * 256 * 256 * 256
    client_code += c[2] * 256 * 256
    client_code += c[1] * 256 
    client_code += c[0] 
    console.log(c)
    //c.map(item => client_code+=item)
    var name = utils.getNameFromDirInjClient(client_code)
    console.log("client_code", client_code)
    console.log(name)
    m.text = utils.byteArrayToHex(c) + " = " + name
    console.log("ext client name", c)
    this.report_progress_gen("READ EXT CLIENT", m)
    await utils.sleep(50)
    return m
  }

  async commGetSN() {
    const m = await this._write_bytes([0x29, 0x00, 0x00], 27, 500)
    if (!m.valid) return undefined
    m.text = ""
    for (var i = 12; i < m._b.length - 1; i++) {
      m.text += String.fromCharCode(m._b[i])
    }
    //console.log(m)
    this.report_progress_gen("READ SERIAL NUMBER", m)
    await utils.sleep(100)
    return m    
  }
  
  async commSetClient(selected_customer) {        
    var m
    var b_code 
    switch (selected_customer) {
      case "AEB":
        b_code = 0x00
        break;
      case "LANDI":
        b_code = 0xfe
        break;
      case "LOVATO":
        b_code = 0x05
        break;
      case "EMMEGAS":
        b_code = 0x16
        break;
      case "ENERGY_REFORM":
        b_code = 40
        break;
      case "CLIENT_FC":
        b_code = 0xfc
        break;
      case "CLIENT_FD":
        b_code = 0xfd
        break;
      case "CLIENT_FF":
        b_code = 0xff
        break;
      default:
        return undefined
    }
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.MP32_NEW: 
      case MyEcu.ECU_TYPE.MP48__MP8C: 
        m = await this._write_bytes([0x12, 0x40, 0, b_code], 8, 250)        
        break;

      case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
        m = await this._write_bytes([0x11, 0x40, b_code], 7, 250)
        break;

      default: 
        return undefined
    }
    if (!m.valid) return undefined
    m.text = "ok"
    //console.log(m)
    this.report_progress_gen("WRITE CLIENT", m)
    await utils.sleep(100)
    return m    
  }
  
  async commSetDirInjClient(value) {        
    var b0 = [0,0,0,0]
    b0[0] = ((value >>  0) & 0xff)
    b0[1] = ((value >>  8) & 0xff)
    b0[2] = ((value >> 16) & 0xff)
    b0[3] = ((value >> 24) & 0xff)
    var b = [0,0,0,0,0,0]
    b[0] = 0;
    b[1] = b0[0] ^ b[0]
    b[2] = b0[1] ^ b[1] 
    b[3] = b0[2] ^ b[2] 
    b[4] = b0[3] ^ b[3] 
    b[5] = (b0[0]+b0[1]+b0[2]+b0[3]) & 0xff
    
    var m = await this._write_bytes([0x00, 0x19, b[0], b[1], b[2], b[3], b[4], b[5]], 8, 250)                
    if (!m.valid) return undefined
    m.text = "ok"
    //console.log(m)
    this.report_progress_gen("WRITE EXT CLIENT", m)
    await utils.sleep(100)
    return m    
  }
  
  get_sub_client_name(code) {
    var items = [
      { name: "AEB",                code: 0x0000, },
      { name: "GREEN",              code: 0x0004, },
      { name: "WENTGAS",            code: 0x0005, },
      { name: "AKL",                code: 0x0006, },
      { name: "PELMAG",             code: 0x0007, },
      { name: "AS",                 code: 0x0008, },
      { name: "BLUE",               code: 0x0009, },
      { name: "AS_ZEICOM",          code: 0x000A, },
      { name: "SCG",                code: 0x000B, },
      { name: "FRONTGAS",           code: 0x000C, },
      { name: "BLUEMEC",            code: 0x000D, },
      { name: "VERDEGAS",           code: 0x000E, },
      { name: "AUTOMOTO",           code: 0x000F, },
      { name: "RAIL",               code: 0x0010, },
      { name: "GASPART",            code: 0x0011, },
      { name: "ALFATRONIC",         code: 0x0012, },
      { name: "GASITALY",           code: 0x0013, },
      { name: "PLINEKS",            code: 0x0014, },
      { name: "GREENGAS",           code: 0x0015, },
      { name: "MSEQUENT",           code: 0x0016, },
      { name: "MEGAJET",            code: 0x0017, },
      { name: "ACEINDIA",           code: 0x0018, },
      { name: "TRONICAG",           code: 0x0019, },
      { name: "LOVATEK",            code: 0x001A, },
      { name: "SITEC",              code: 0x001B, },
      { name: "FYDA",               code: 0x001C, },
      { name: "CENERGY",            code: 0x001D, },
      { name: "GRECO",              code: 0x001E, },
      { name: "ALEX",               code: 0x001F, },
      { name: "SETALTAS",           code: 0x0020, },
      { name: "AUTOGAS_IT",         code: 0x0021, },
      { name: "STEFANO_UK",         code: 0x0022, },
      { name: "MIRAE",              code: 0x0023, },
      { name: "LABTECH",            code: 0x0024, },
      { name: "CORTINA",            code: 0x0025, },
      { name: "EPSILON",            code: 0x0026, },
      { name: "BUONARIA",           code: 0x0027, },
      { name: "TECNOFABRICA",       code: 0x0028, },
      { name: "REAGAS",             code: 0x0029, },
      { name: "MITIG",              code: 0x002A, },
      { name: "ALDESA",             code: 0x002B, },
      { name: "ACON",               code: 0x002C, },
      { name: "MGMOTORGAS",         code: 0x002D, },
      { name: "KNC",                code: 0x002E, },
      { name: "ZAMEL",              code: 0x002F, },
      { name: "MOTOZEN",            code: 0x0030, },
      { name: "BONGAS",             code: 0x0031, },
      { name: "ALPHA",              code: 0x0032, },
      { name: "AEBCINA",            code: 0x0033, },
      { name: "GGASFOREVER",        code: 0x0034, },
      { name: "EGEUROGAS",          code: 0x0035, },
      { name: "MIMGAS",             code: 0x0036, },
      { name: "SPARK",              code: 0x0037, },
      { name: "ITATRONIC",          code: 0x0038, },
    ]
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.code === code) {
        return item.name
      }
    }
    return undefined
  }

  async commGetSubClient() {    
    var m
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.DI60: 
        m = await this._write_bytes([0x09, 0xD4, 0x00], 8, 250)        
        break;
      
      default: 
        m = await this._write_bytes([0x09, 0x33, 0x00], 9, 200)
        break;
    }
    if (!m.valid) return undefined

    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.DI60: 
        m.text = utils.decimalToHex(m._b[6])
        break;
      
      default: 
        m.text = utils.decimalToHex(m._b[7]) + utils.decimalToHex(m._b[6])
        var sub_client_code = m._b[7] * 256 + m._b[6]
        var sub_client_name = this.get_sub_client_name(sub_client_code)
        console.log("sub_client_name", sub_client_name)
        if (sub_client_name !== undefined)
          m.text += " [" + sub_client_name + "]"
        break;
    }    
    
    this.report_progress_gen("READ SUB CLIENT", m)
    await utils.sleep(100)
    return m    
  }

  async commGetProdMarker() {    
    const m = await this._write_bytes([0x09, 0x01, 0x00], 8, 200)
    if (!m.valid) return undefined
    m.text = utils.decimalToHex(m._b[6])
    if (m._b[6] === 1) {
      m.Text = " (ecu has never been coonected to the calibration tool)"
    }
    //console.log(m)
    this.report_progress_gen("READ PROD MARKER", m)
    await utils.sleep(100)
    return m    
  }

  async commSetSubClient(a_sub_client_code) {    
    var m
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.MP32_NEW: 
      case MyEcu.ECU_TYPE.MP48__MP8C: 
        m = await this._write_bytes([0x13, 0x33, 0, a_sub_client_code[1], a_sub_client_code[0]], 9, 250)        
        break;

      case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
        m = await this._write_bytes([0x12, 0x33, a_sub_client_code[1], a_sub_client_code[0]], 8, 250)        
        break;
      
      default: 
        return undefined
    }
    if (!m.valid) return undefined
    m.text = "ok"
    //console.log(m)
    this.report_progress_gen("WRITE SUB CLIENT", m)
    await utils.sleep(100)
    return m    
  }

  async commSetModelCode(a_model_code) {    
    var m
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.MP32_NEW: 
      case MyEcu.ECU_TYPE.MP48__MP8C: 
        m = await this._write_bytes([0x12, 0x41, 0, a_model_code[0]], 8, 250)        
        break;

      case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
        m = await this._write_bytes([0x11, 0x41, a_model_code[0]], 7, 250)
        break;

      default: 
        return undefined
    }
    if (!m.valid) return undefined
    m.text = "ok"
    //console.log(m)
    this.report_progress_gen("WRITE MODEL CODE", m)
    await utils.sleep(100)
    return m    
  }

  async commSetProdMarker(value) {    
    var m
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.MP32_NEW: 
      case MyEcu.ECU_TYPE.MP48__MP8C: 
        m = await this._write_bytes([0x12, 0x01, 0, value], 8, 250)        
        break;

      case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
        m = await this._write_bytes([0x11, 0x01, value], 7, 250)        
        break;

      default: 
        return undefined
    }
    if (!m.valid) return undefined
    m.text = "ok"
    //console.log(m)
    this.report_progress_gen("WRITE PROD MARKER", m)
    await utils.sleep(100)
    return m    
  }
  
  async commGetIdPcb() {
    var m
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.DI60: 
        m = await this._write_bytes([0x29, 0x3E, 0x00], 11, 250)        
        break;
        
      default: 
        m = await this._write_bytes([0x29, 0x13, 0x00], 11, 250)
        break;
    }
    if (!m.valid) return undefined
    m.w0 = [ m._b[7], m._b[6] ]
    m.w1 = [ m._b[9], m._b[8] ]
    //console.log(m)
    this.report_progress({ type: "id_pcb", title: "READ ID PCB", data: m })
    await utils.sleep(100)
    return m
  }

  async commSetIdPcb(a_w0, a_w1) {    
    var m
    switch (this.ecu_type)
    { 
      case MyEcu.ECU_TYPE.MP32_NEW:      
      case MyEcu.ECU_TYPE.MP48__MP8C: 
        // esteso 2 byte 
        m = await this._write_bytes([0x35, 0x13, 0, a_w0[1], a_w0[0], a_w1[1], a_w1[0]], 11, 250)        
        break;

      case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
        // esteso normale
        m = await this._write_bytes([0x34, 0x13, a_w0[1], a_w0[0], a_w1[1], a_w1[0]], 10, 250)        
        break;

      case MyEcu.ECU_TYPE.DI60: 
        m = await this._write_NONE()
        break;

      default: 
        return undefined
    }
    if (!m.valid) return undefined
    m.text = "ok"
    //console.log(m)
    this.report_progress_gen("WRITE ID PCB", m)
    await utils.sleep(100)
    return m    
  }

  async commCmdLeaveBoot() {
    const m = await this._write_bytes([0x00, 0x0B], 7, 250)
    if (!m.valid) return undefined
    //console.log(m)
    this.report_progress_gen("CMD LEAVE BOOT", m)
    await utils.sleep(250)
    return m
  }

  async commCmdJumpInBoot() {
    var m
    switch (this.ecu_type)
    {
      case MyEcu.ECU_TYPE.MP32_NEW: 
      case MyEcu.ECU_TYPE.MP48__MP8C: 
        m = await this._write_bytes([0x12, 0x02, 0, 0xff], 8, 250)
        break;
      
      case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
        m = await this._write_bytes([0x11, 0x02, 0xff], 8, 250) 
        break;

      case MyEcu.ECU_TYPE.DI60:
        m = await this._write_NONE()
        break;

      default: 
        return undefined
    }
    //console.log("write checkup 0xF0")
    if (!m.valid) return undefined
    //console.log(m)
    this.report_progress_gen("CMD JUMP IN BOOT", m)
    await utils.sleep(100)
    return m
  }

  async commCmdMemSave() {
    // var m
    // switch (this.ecu_type)
    // { 
    //   case MyEcu.ECU_TYPE.MP32_NEW:      
    //   case MyEcu.ECU_TYPE.MP48__MP8C: 
    //     // esteso 2 byte 
    //     // SEMBRA INVERTITO QUESTO ... O FORSE NO?
    //     // POI L'HO RIMESSO COME PRIMA ...
    //     m = await this._write_bytes([0x01, 0x12, 0], 7, 250)
    //     //m = await this._write_bytes([0x01, 0x12], 6, 250)        
    //     break;      
    //   case MyEcu.ECU_TYPE.MP32__MP48_OBD: 
    //     // esteso normale
    //     // LO INVERTO CON QUELLO SOPRA! ... DA CHIARIRE ?!?! 
    //     // POI L'HO RIMESSO COME PRIMA ...
    //     m = await this._write_bytes([0x01, 0x12], 6, 250)        
    //     //m = await this._write_bytes([0x01, 0x12, 0], 7, 250)
    //     break;      
    //   default: 
    //     return undefined
    // }

    // DOPPIO TENTATIVO PERCHE' NON SI CAPISCE QUALE SIA IL COMANDO GIUSTO
    // ANCHE GIRANDOLI E RIGIRANDOLI NON SEMBRA SEMPRE FUNZIONARE 
    
    var m0 = await this._write_bytes([0x01, 0x12, 0], 7, 250)
    if (!m0.valid) return undefined
    if (m0._b[4] == 0x53) 
    {
      this.report_progress_gen("CMD MEM SAVE", m0)
      await utils.sleep(100)
      return m0
    }
        
    var m1 = await this._write_bytes([0x01, 0x12], 6, 250) 
    if (!m1.valid) return undefined
    if (m1._b[3] == 0x53) 
    {
      this.report_progress_gen("CMD MEM SAVE", m1)
      await utils.sleep(100)
      return m1
    }

    this.report_progress_gen("CMD MEM SAVE", m1)
    await utils.sleep(100)
    return m1
  }

  // **************************************************************************
  // **************************************************************************
  // **************************************************************************

  async _read_until_closed() {
    while (this.port.readable && this.keepReading) {
      this.reader = this.port.readable.getReader();
      try {
        while (true) {
          const {
            value,
            done
          } = await this.reader.read();
          if (done) {
            // reader.cancel() has been called.
            break;
          }
          // value is a Uint8Array.
          for (var v of value) {
            this.rxBytes.push(v)
            //console.log(decimalToHex(v));
            //console.log(value);
          }
        }
      } catch (error) {
        // Handle error...
      } finally {
        // Allow the serial port to be closed later.
        this.reader.releaseLock();
      }
    }
    await this.port.close();
    console.log("read until ending")
  }

  async _ecu_done() {
    // User clicked a button to close the serial port.
    this.keepReading = false
    // Force reader.read() to resolve immediately and subsequently
    // call reader.releaseLock() in the loop example above.
    this.reader.cancel()
    await this.closedPromise
    this.reader = undefined
    console.log("read until end")
  }

  async _write_NONE() {
    return {
      ret: true,
      valid: true,
      _b: [],
    }
  }
  async _write_bytes(tx_bytes, bytes_to_read, to) {
    var ret = false
    var crc = 0    
    tx_bytes.map(b => crc += b)
    tx_bytes.push(crc & 0xff)
    this.rxBytes = []
    await this.writer.write(new Uint8Array(tx_bytes));
    while (this.rxBytes.length < bytes_to_read) {
      await utils.sleep(10)
      to -= 10
      if (to < 0) {
        return {
          ret: ret,
          valid: false,
          _b: this.rxBytes.map(obj => obj),
        }
      }
    }
    var pos = tx_bytes.length
    if (pos < this.rxBytes.length)
      if (this.rxBytes[pos] === 0x53)
        ret = true
    return {
      ret: ret,
      valid: true,
      _b: this.rxBytes.map(obj => obj),
    }
  }

}

export default MyEcu;
